<template>
  <div class="tasks">
    <span class="title">
      <span>📝</span>
      Tasks
    </span>

    <div class="container">
      <ul class="tasks-list" v-if="filteredTasks.length > 0">
        <li class="task" v-for="task in filteredTasks" :key="task.id">
          <div class="flex task-info">
            <span class="task-title">{{ task.title }}</span>
          </div>
          <div class="flex task-bth">
            <img src="@/assets/Fw3P.gif" class="wallet-icon">
            <span>{{ task.config.bth }}</span>
          </div>

          <div class="buttons flex task-buttons">
            <button
                v-if="!task.dailyVisitClicked"
                :href="task.config.link"
                :data-target="task.config.target"
                @click="task.config.id === 'telegram' ? goOrCheckTask(task) : startTask(task)"
                :class="{ 'check-failed': task.checkFailed }"
            >
              {{ task.config.id === 'telegram' && task.clicked ? 'Check' : task.config.button }}
            </button>
          </div>
        </li>
      </ul>
      <div v-else class="no-tasks">
        <p>🎉 No tasks available right now. Daily tasks refresh every 24 hours. Don't forget to come back! 🚀</p>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { mapState } from 'vuex';

export default {
  name: 'TasksView',
  data() {
    return {
      tasks: [],
      user: {}
    };
  },
  computed: {
    ...mapState(['clickedTasks']),
    filteredTasks() {
      return this.tasks.filter(task => !task.checked);
    }
  },
  methods: {
    fetchTasks() {
      axios.post('https://sys.bitherin.com/telegram/tasks', {
        telegram_id: this.$route.query.telegram_id
      }).then(response => {
        if (response.data.success) {
          this.tasks = response.data.tasks.map(task => {
            task.config = JSON.parse(task.config);
            task.checked = false;
            task.checkFailed = false;
            task.clicked = this.clickedTasks.includes(task.id);
            task.dailyVisitClicked = false;
            return task;
          });
          this.user = response.data.user;
        } else {
          console.error(response.data.message);
        }
      }).catch(error => {
        console.error('Error fetching tasks:', error);
      });
    },
    startTask(task) {
      const target = task.config.target;
      const href = 'https://sys.bitherin.com/' + task.config.route + '/' + this.user.id + '/' + task.id + "?platform=telegram";

      if (task.config.id === "dailyvisit") {
        task.dailyVisitClicked = true;
      }

      if (target === 'external') {
        window.open(href, '_system');
      } else {
        window.location.href = href;
      }
    },
    goOrCheckTask(task) {
      if (task.clicked) {
        this.checkTask(task);
      } else {
        this.$store.commit('ADD_CLICKED_TASK', task.id);
        const href = task.config.link;
        window.location.href = href;
      }
    },
    checkTask(task) {
      axios.post('https://sys.bitherin.com/telegramapicheck', {
        telegram_user_id: this.$route.query.telegram_id,
        userid: this.user.id,
        taskid: task.id,
        platform: "telegram"
      }).then(response => {
        if (response.data.success) {
          task.checked = true;
          this.$store.commit('REMOVE_CLICKED_TASK', task.id); // Başarılıysa tıklanan görev listesinden çıkar
        } else {
          task.checkFailed = true;
          setTimeout(() => {
            task.checkFailed = false;
            task.clicked = false; // Hata durumunda tekrar Go butonuna dön
            this.$store.commit('REMOVE_CLICKED_TASK', task.id); // Başarısızsa tıklanan görev listesinden çıkar
          }, 1000);
        }
      }).catch(error => {
        task.checkFailed = true;
        setTimeout(() => {
          task.checkFailed = false;
          task.clicked = false; // Hata durumunda tekrar Go butonuna dön
          this.$store.commit('REMOVE_CLICKED_TASK', task.id); // Başarısızsa tıklanan görev listesinden çıkar
        }, 1000);
        console.error('Error checking task:', error);
      });
    }
  },
  created() {
    this.fetchTasks();
  }
}
</script>

<style scoped>
.title {
  color: #ffa500;
  font-size: 17px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 10px;
  justify-content: center;
  letter-spacing: .5px;
}

ul {
  padding: 0;
  margin: 0;
  list-style: none;
}

.tasks {
  text-align: center;
  padding: 20px;
  background-color: #0d1319;
  color: #fff;
  height: 100%;
}

.container {
  padding: 10px 12px;
}

.flex {
  display: flex;
  align-items: center;
  gap: 5px;
}

.task {
  padding: 10px 8px;
  border-bottom: 2px solid #040C14;
  border-radius: 3px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.task-info, .task-bth, .task-buttons {
  text-align: center;
}

.task-info {
  flex: 2;
  text-align: left;
}

.task-title {
  display: inline-block;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.task-bth {
  flex: 1;
  justify-content: center;
}

.buttons {
  flex: 1;
  display: flex;
  gap: 10px;
  justify-content: center;
}

button {
  border: 1px solid #040C14;
  background: linear-gradient(to right, #ffa500, #ff4500);
  color: #fff;
  padding: 4px 8px;
  border-radius: 4px;
  font-weight: 500;
  font-size: 15px;
}

button.check-failed {
  background: linear-gradient(to right, #ff4500, #ff0000);
}

.task:nth-child(even) {
  background-color: #020202;
}

.tasks-list {
  margin-top: 15px;
}

.wallet-icon {
  width: 20px;
}

.no-tasks {
  text-align: center;
  margin-top: 20px;
  font-size: 16px;
  color: #ffa500;
}
</style>
